import { io } from 'socket.io-client';
import {
  NODE_WEBSOCKET_ADDRESS,
  STETHOSCOPE_EVENTS,
  IOT_WEBSOCKET_ADDRESS,
} from '@/Utils/vice-constants';

/**
 * The session_uniqueId stripped of the (-) separator
 * @param {*} sessionId
 */
export const SocketioClient = (sessionId) => {
  console.log({ NODE_WEBSOCKET_ADDRESS });
  const socket = io(NODE_WEBSOCKET_ADDRESS, { transports: ['websocket'] });
  // const stethoscopeSocket = io(`${IOT_WEBSOCKET_ADDRESS}:${IOT_WEBSOCKET_PORT}/stethoscope`, {
  //   transports: ['websocket'],
  // query: {
  //   sesssionId: sessionId,
  // },
  // });

  return new Promise((resolve, reject) => {
    socket.on(STETHOSCOPE_EVENTS.CONNECT, () => {
      // join the session now.
      console.log('Add stethoscope to devices list (devicemanager)');
      console.log('join the session');
      socket.emit(STETHOSCOPE_EVENTS.JOIN, sessionId);
      resolve(socket);
    });

    socket.on('error', (error) => {
      console.error('error connecting');
      reject(error);
    });
  });
};

export const SmartGlassesClient = (sessionId) => {
  const smartglassesSocket = io(`${IOT_WEBSOCKET_ADDRESS}/smartglasses`, {
    transports: ['websocket'],
    query: {
      sessionId,
      deviceType: 'desktop',
    },
  });

  return new Promise((resolve, reject) => {
    smartglassesSocket.on(STETHOSCOPE_EVENTS.CONNECT, () => {
      resolve(smartglassesSocket);
    });

    smartglassesSocket.on('error', (error) => {
      console.error('error connecting');
      reject(error);
    });
  });
};
